/**
 * Change handler
 */

const handler: EventListener = ( event: Event ) => {
	const element = event.target;

	if (
		element instanceof HTMLInputElement &&
		element.closest( '.quantity' )
	) {
		const qty = element.value;

		if ( ! isNaN( Number( qty ) ) ) {
			const button = element
				.closest( 'form.add-to-cart-form' )
				?.querySelector( '.add_to_cart_button' );

			if ( button instanceof HTMLButtonElement ) {
				button.dataset.quantity = qty;
			}
		}
	}
};

export default handler;
